"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var IndoorLight = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M12,20 L12,22 L11,22 L11,20 L12,20 Z M7.85355339,18.1464466 C8.02711974,18.320013 8.04640489,18.5894374 7.91140884,18.7843055 L7.85355339,18.8535534 L6.85355339,19.8535534 C6.65829124,20.0488155 6.34170876,20.0488155 6.14644661,19.8535534 C5.97288026,19.679987 5.95359511,19.4105626 6.08859116,19.2156945 L6.14644661,19.1464466 L7.14644661,18.1464466 C7.34170876,17.9511845 7.65829124,17.9511845 7.85355339,18.1464466 Z M15.8535534,18.1464466 L16.8535534,19.1464466 C17.0488155,19.3417088 17.0488155,19.6582912 16.8535534,19.8535534 C16.6582912,20.0488155 16.3417088,20.0488155 16.1464466,19.8535534 L15.1464466,18.8535534 C14.9511845,18.6582912 14.9511845,18.3417088 15.1464466,18.1464466 C15.3417088,17.9511845 15.6582912,17.9511845 15.8535534,18.1464466 Z M15,4 L15,5 L12,5 C12,7.66666667 12,9 12,9 C15.1896578,9.24449921 17.7387488,11.8104141 17.9811062,15.0006709 L18,16 L14.6634425,15.9994566 C14.1018217,17.1822232 12.8964118,18 11.5,18 C10.1035882,18 8.89817835,17.1822232 8.33655751,15.9994566 L5,16 L5.01889382,15.0006709 C5.26148557,11.807329 7.80601185,9.24027721 11,9 C11,9 11,7.66666667 11,5 L8,5 L8,4 L15,4 Z M13.4998491,16.0004445 L9.50015087,16.0004445 C9.9562745,16.607415 10.6822907,17 11.5,17 C12.3177093,17 13.0437255,16.607415 13.4998491,16.0004445 Z M11.5,10 C8.63084455,10 6.27481555,12.1969555 6.02238608,15.0003933 L16.9776139,15.0003933 C16.7251845,12.1969555 14.3691554,10 11.5,10 Z" })));
};
IndoorLight.displayName = 'IndoorLight';
exports.default = IndoorLight;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=IndoorLight.js.map